"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueEditor = exports.toSchema = void 0;
var react_1 = __importStar(require("react"));
var Box_1 = require("../Box");
var Stack_1 = require("../Stack");
var KeyValueInput_1 = require("../KeyValueInput");
var Remove_1 = require("../Remove");
var Tooltip_1 = require("../Tooltip");
var toSchema = function (data) {
    return Object.keys(data).map(function (name) {
        var type = typeof data[name];
        if (!(type === "string" || type === "number")) {
            throw new Error("Schema invalid");
        }
        return { key: name, name: name, type: type };
    });
};
exports.toSchema = toSchema;
var reducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case "ADD_FIELD": {
            if (state.schema.find(function (_a) {
                var name = _a.name;
                return name === action.payload.name;
            })) {
                return state;
            }
            return __assign(__assign({}, state), { edited: true, schema: __spreadArray(__spreadArray([], __read(state.schema), false), [
                    {
                        key: action.payload.name,
                        name: action.payload.name,
                        type: "string",
                    },
                ], false), nextKey: "".concat(new Date().getTime()) });
        }
        case "REMOVE_FIELD": {
            var _c = state.data, _d = action.payload.name, removed = _c[_d], nextData = __rest(_c, [typeof _d === "symbol" ? _d : _d + ""]);
            var nextSchema = state.schema.filter(function (_a) {
                var name = _a.name;
                return name !== action.payload.name;
            });
            return __assign(__assign({}, state), { edited: true, schema: nextSchema, data: nextData });
        }
        case "UPDATE_NAME": {
            var _e = state.data, _f = action.payload.oldName, removed = _e[_f], filteredData = __rest(_e, [typeof _f === "symbol" ? _f : _f + ""]);
            var nextData = __assign(__assign({}, filteredData), (action.payload.newName !== ""
                ? (_a = {}, _a[action.payload.newName] = state.data[action.payload.oldName], _a) : {}));
            var nextSchema = state.schema
                .map(function (field, index) {
                if (index !== action.payload.index)
                    return field;
                return {
                    key: field.key,
                    name: action.payload.newName,
                    type: field.type,
                };
            })
                .filter(function (_a) {
                var name = _a.name;
                return name !== "";
            });
            return __assign(__assign({}, state), { edited: true, schema: nextSchema, data: nextData });
        }
        case "UPDATE_VALUE":
            return __assign(__assign({}, state), { edited: true, data: __assign(__assign({}, state.data), (_b = {}, _b[action.payload.key] = action.payload.value, _b)) });
    }
};
exports.KeyValueEditor = react_1.default.memo(function (_a) {
    var initialSchema = _a.schema, initialData = _a.data, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, rest = __rest(_a, ["schema", "data", "onChange"]);
    var _c = __read((0, react_1.useReducer)(reducer, {
        edited: false,
        schema: initialSchema,
        data: initialData,
        nextKey: "".concat(new Date().getTime()),
    }), 2), state = _c[0], dispatch = _c[1];
    var handleNameChange = (0, react_1.useCallback)(function (_a) {
        var oldName = _a.name, index = _a.index;
        return function (_a) {
            var newName = _a.target.value;
            dispatch({ type: "UPDATE_NAME", payload: { oldName: oldName, newName: newName, index: index } });
        };
    }, []);
    var handleValueChange = (0, react_1.useCallback)(function (key) { return function (_a) {
        var value = _a.target.value;
        dispatch({ type: "UPDATE_VALUE", payload: { key: key, value: value } });
    }; }, []);
    var handleAddField = (0, react_1.useCallback)(function (_a) {
        var name = _a.target.value;
        if (name === "")
            return;
        dispatch({ type: "ADD_FIELD", payload: { name: name } });
    }, []);
    var handleRemove = (0, react_1.useCallback)(function (name) { return function () {
        return dispatch({ type: "REMOVE_FIELD", payload: { name: name } });
    }; }, []);
    (0, react_1.useEffect)(function () {
        if (!state.edited)
            return;
        onChange(state.data);
    }, [onChange, state.data, state.edited]);
    return (react_1.default.createElement(Stack_1.Stack, __assign({}, rest),
        state.schema.map(function (field, index) { return (react_1.default.createElement(Box_1.Box, { key: field.key, position: "relative" },
            react_1.default.createElement(KeyValueInput_1.KeyValueInput, { k: {
                    onChange: handleNameChange({ name: field.name, index: index }),
                    placeholder: "name",
                    defaultValue: field.name,
                    autoComplete: "off",
                }, v: {
                    onChange: handleValueChange(field.name),
                    placeholder: field.name,
                    defaultValue: state.data[field.name],
                    autoComplete: "off",
                    autoFocus: state.schema.length > initialSchema.length &&
                        index === state.schema.length - 1,
                } }),
            react_1.default.createElement(Tooltip_1.Tooltip, { label: "remove ".concat(field.name), placement: "left", distance: 0 },
                react_1.default.createElement(Remove_1.Remove, { position: "absolute", top: 0, right: 0, bottom: 0, px: 6, onClick: handleRemove(field.name) })))); }),
        react_1.default.createElement(KeyValueInput_1.KeyValueInput, { key: state.nextKey, k: {
                onBlur: handleAddField,
                placeholder: "add field",
                autoComplete: "off",
            } })));
});
exports.KeyValueEditor.displayName = "KeyValueEditor";
//# sourceMappingURL=KeyValueEditor.js.map